import { Brand } from '@awaze/design-system.components.awaze-theme-provider'

export const novasolPoweredBrands = ['novasol', 'fincallorca', 'jamesVillas']

export const isNovasolPoweredBrand = (brand: Brand): boolean =>
  novasolPoweredBrands.includes(brand)
